var map = {
	"./backgrounds/office_lobby.jpg": 389,
	"./backgrounds/older_woman_ipad.jpg": 390,
	"./backgrounds/smart_home_health.jpg": 326,
	"./graphics/ipad_pro_3.png": 327,
	"./graphics/ipad_pro_mockup.png": 238,
	"./graphics/ipad_pro_mockup_2.png": 239,
	"./graphics/iphone_max.png": 240,
	"./graphics/nurse_doctor_ipad.png": 328,
	"./graphics/nurse_ipad_reception.png": 329,
	"./health_data_network.jpg": 391,
	"./living_facility.jpg": 392,
	"./residents/resident_avatar_female.png": 247,
	"./residents/resident_avatar_male.png": 325,
	"./residents/woman_01.png": 248,
	"./residents/woman_02.png": 249,
	"./residents/woman_03.png": 250,
	"./residents/woman_04.png": 251,
	"./residents/woman_05.png": 252,
	"./residents/woman_06.png": 253,
	"./residents/woman_07.png": 254,
	"./residents/women.psd": 393,
	"./screens/spec_activity.png": 259,
	"./screens/spec_careplan.png": 256,
	"./screens/spec_chart.png": 255,
	"./screens/spec_diet.png": 260,
	"./screens/spec_labs.png": 262,
	"./screens/spec_meds.png": 261,
	"./screens/spec_notes.png": 258,
	"./screens/spec_residents.png": 324,
	"./screens/spec_vitals.png": 257,
	"./smart_health.png": 394,
	"./spectator_logo.png": 395,
	"./spectator_logo.svg": 242
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 388;